import { default as _axios } from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { getToken, getUserContextIds } from "@/utils/sessionStorage";
import { getRuntimeConfig } from "@/utils/runtimeConfig";

dayjs.extend(utc);

//@ts-expect-error Not sure
delete Date.prototype.toJSON;

Date.prototype.toJSON = function () {
  return dayjs(this).utc().format("YYYY-MM-DDTHH:mm:ss.000") + "Z";
};

const axios = _axios.create();
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    const ids = getUserContextIds() || {};
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (ids.userId) config.headers["UserId"] = ids.userId;
    if (ids.companyId) config.headers["CompanyId"] = ids.companyId;
    // if (ids.companyId) config.headers["companyId"] = ids.companyId;
    config.headers["SiteId"] = SITE_ID;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const refreshTokenAxios = _axios.create();
refreshTokenAxios.interceptors.request.use(
  (config) => {
    const token = getToken();
    const ids = getUserContextIds() || {};
    config.headers["Content-Type"] = "application/json";
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (ids.userId) config.headers["UserId"] = ids.userId;
    if (ids.companyId) config.headers["CompanyId"] = ids.companyId;
    config.headers["SiteId"] = SITE_ID;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API paths are relative: the browser resolves them against the origin that served the
// page, and the ingress (or the Vite dev proxy) routes each prefix to its service. This
// is what lets one image serve any white-label domain, so no per-service host is needed.
const HOST_DEVELOPMENT_MOCK = getRuntimeConfig("HOST_DEVELOPMENT_MOCK");
const SITE_ID = getRuntimeConfig("SITE_ID");
const IS_DEV = import.meta.env.NODE_ENV === "development";
const IS_MOCK = !!import.meta.env.VITE_MOCK;
const PROTOCOL = window.location.protocol;

let APIBASE_REVIVERUSERS: string;
let APIBASE_REVIVERAPPLICATION: string;
let APIBASE_REVIVERCONTRACTS: string;
let APIBASE_REVIVERAUTHENTICATION: string;
let APIBASE_REVIVERDOCUMENTARCHIVE: string;
let APIBASE_REVIVERAUCTION: string;
let APIBASE_REVIVERACCOUNTING: string;
let APIBASE_REVIVERTRANSPORT: string;
let APIBASE_REVIVERMESSAGING: string;
let APIBASE_REVIVERTASKS: string;
let APIBASE_REVIVERFEEDBACK: string;
let APIBASE_REVIVERCLAIMS: string;
let APIBASE_REVIVERCAMERACONTROL: string;
const IS_DEV_NOT_MOCK = IS_DEV && !IS_MOCK;

if (IS_DEV && IS_MOCK) {
  const common = `${PROTOCOL}//${HOST_DEVELOPMENT_MOCK}/`;
  APIBASE_REVIVERUSERS = common;
  APIBASE_REVIVERAPPLICATION = common;
  APIBASE_REVIVERCONTRACTS = common;
  APIBASE_REVIVERAUTHENTICATION = common;
  APIBASE_REVIVERDOCUMENTARCHIVE = common;
  APIBASE_REVIVERAUCTION = common;
  APIBASE_REVIVERACCOUNTING = common;
  APIBASE_REVIVERTRANSPORT = common;
  APIBASE_REVIVERMESSAGING = common;
  APIBASE_REVIVERTASKS = common;
  APIBASE_REVIVERFEEDBACK = common;
  APIBASE_REVIVERCLAIMS = common;
  APIBASE_REVIVERCAMERACONTROL = common;
} else {
  APIBASE_REVIVERAPPLICATION = "/app/";
  APIBASE_REVIVERCONTRACTS = "/con/";
  APIBASE_REVIVERUSERS = "/usr/";
  APIBASE_REVIVERAUTHENTICATION = "/auth/";
  APIBASE_REVIVERDOCUMENTARCHIVE = "/archive/";
  APIBASE_REVIVERAUCTION = "/auc/";
  APIBASE_REVIVERACCOUNTING = "/acc/";
  APIBASE_REVIVERTRANSPORT = "/trans/";
  APIBASE_REVIVERMESSAGING = "/msg/";
  APIBASE_REVIVERTASKS = "/tasks/";
  APIBASE_REVIVERFEEDBACK = "/fb/";
  APIBASE_REVIVERCLAIMS = "/claims/";
  APIBASE_REVIVERCAMERACONTROL = "/camera/";
}

export {
  APIBASE_REVIVERUSERS,
  APIBASE_REVIVERAPPLICATION,
  APIBASE_REVIVERCONTRACTS,
  APIBASE_REVIVERAUTHENTICATION,
  APIBASE_REVIVERDOCUMENTARCHIVE,
  APIBASE_REVIVERAUCTION,
  APIBASE_REVIVERACCOUNTING,
  APIBASE_REVIVERTRANSPORT,
  APIBASE_REVIVERMESSAGING,
  APIBASE_REVIVERTASKS,
  APIBASE_REVIVERFEEDBACK,
  APIBASE_REVIVERCLAIMS,
  APIBASE_REVIVERCAMERACONTROL,
  SITE_ID,
  IS_DEV_NOT_MOCK,
  IS_DEV,
  axios,
  refreshTokenAxios,
};
